import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-28 pb-20 bg-[#F9F6F0] relative overflow-hidden">
      {/* Background drifting blobs */}
      <div className="bg-blob blob-gold top-[10%] left-[-5%] w-[400px] h-[400px] opacity-30" />
      <div className="bg-blob blob-saffron bottom-[15%] right-[-5%] w-[450px] h-[450px] opacity-35" />

      <div className="container mx-auto max-w-4xl px-6 md:px-12 relative z-10">
        
        {/* Header */}
        <div className="text-left mb-10">
          <span className="text-[10px] font-bold tracking-widest uppercase text-[#D97706] mb-2 block">
            Data Privacy
          </span>
          <h1 className="text-3xl md:text-4xl font-bold font-vedic text-[#352520]">
            Privacy Policy
          </h1>
        </div>

        {/* Content Box */}
        <div className="bg-white/60 backdrop-blur-md border border-[#EBE6DD]/60 rounded-3xl p-8 md:p-12 shadow-lg space-y-10 text-left">
          
          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">01</span>
              Information We Collect
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              We collect information you provide directly, including name, email, and uploaded floor
              plans. We also collect usage data to improve our services.
            </p>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">02</span>
              How We Use Your Information
            </h2>
            <ul className="list-disc list-inside space-y-3 text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              <li>To provide and improve VastuAI services and system accuracy</li>
              <li>To generate AI-powered Vastu analysis, overlays, and suggestions</li>
              <li>To communicate with you about updates, features, and consulting appointments</li>
              <li>To ensure security and prevent unauthorized access or fraud</li>
            </ul>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">03</span>
              Data Security
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              We implement industry-standard security measures to protect your data. Floor plans are
              encrypted during transmission and storage. However, no method of transmission over the
              internet is 100% secure.
            </p>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">04</span>
              Data Sharing
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              We do not sell your personal information. We may share data with service providers who
              assist in operations, subject to strict confidentiality agreements.
            </p>
          </section>

          <section className="border-b border-[#EBE6DD]/40 pb-8">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">05</span>
              Your Rights
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              You have the right to access, correct, or delete your personal data. Contact us at
              privacy@vastuai.com for data requests.
            </p>
          </section>

          <section className="pb-2">
            <h2 className="text-lg md:text-xl font-bold font-vedic text-[#352520] mb-4 flex items-center">
              <span className="text-[#D97706] font-mono text-base mr-3">06</span>
              Cookies
            </h2>
            <p className="text-sm md:text-base text-[#5D4E37] font-light leading-relaxed">
              We use cookies and similar technologies to enhance user experience and analyze usage
              patterns. You can control cookie preferences through your browser settings.
            </p>
          </section>

          <div className="pt-6 border-t border-[#EBE6DD]/40 text-left">
            <span className="text-xs text-[#826239] font-medium tracking-wide uppercase">
              Last updated: January 2025
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
